<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">
            折扣活动
            <div class="search-input">
              <Input v-model="cxName" size="small" placeholder="请输入名称搜索" search />
            </div>
          </div>
          <div class="card-body padding-top0">
            <div class="card-menu">
              <Button type="primary" icon="md-add" @click="addClick" style="margin-right: 10px">新增</Button>
              <Button type="error" icon="md-trash" @click="allDel" :loading="loading"
                :disabled="Selection.length==0?true:false">删除所选</Button>
            </div>
            <div v-if="data.length == 0 && !load">
              <Empty :text="'暂无数据'"></Empty>
            </div>
            <div v-else>
              <Alert show-icon v-if="$store.state.isMobile">移动设备请左右滑动翻阅</Alert>
              <Table ref="selection" :loading="load" border :columns="columns" :data="data" @on-selection-change="handleSelectChange">
                <template slot-scope="{ row }" slot="status">
                  <Badge v-if="row.status === 0" status="error" text="已停用" />
                  <Badge v-if="row.status === 1" status="success" text="已启用" />
                </template>
                <template slot-scope="{ row }" slot="action">
                  <Button type="primary" size="small" style="margin-right: 5px" @click="editClick(row)">编辑</Button>
                  <Button type="error" size="small" @click="del(row.id)">删除</Button>
                </template>
              </Table>
              <div class="paging">
                <Page :total="Number(total)" :current="pageIndex" :page-size="pageSize" :simple="$store.state.isMobile"
                  @on-change="pageChange" @on-page-size-change="pageSizeChange" show-total show-sizer show-elevator />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="showCreate" :title="edit ? '编辑活动' : '新增活动'" :loading="creating" :width="600"
      @on-ok="edit ? editSave() : addSave()">
      <Form ref="create" :model="createData" :rules="createRules" :label-width="110">
        <FormItem label="活动名称：" prop="name">
          <Input v-model="createData.name" placeholder="请输入名称" />
        </FormItem>

        <FormItem label="活动开始时间：" prop="time">
          <DatePicker type="datetime" v-model="createData.starttime" format="yyyy-MM-dd HH:mm:ss" :editable="false"
            @on-change="startChange" placeholder="请选择活动开始时间" style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem label="活动结束时间：" prop="time">
          <DatePicker type="datetime" v-model="createData.endtime" format="yyyy-MM-dd HH:mm:ss" :editable="false"
            @on-change="endChange" placeholder="请选择活动结束时间" style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem label="折扣后比例：" prop="discount">
          <InputNumber v-model="createData.discount" :max="99" :step="1" :min="0" placeholder="请输入折扣比例 1-99"
            style="width: 70%">
          </InputNumber>%
          <Tooltip content="例:输入80表示在原基础上打8折" placement="bottom-end">
            <span class="iconfont icon-wenhao help"></span>
          </Tooltip>
          <div v-if="createData.discount">
            <p class="sm" style="margin-top:10px">当前实际售价为商品原价的 {{createData.discount}}% </p>
            <p class="sm">例：商品价格50元，折扣后为 {{createData.discount/100 * 50}}元 </p>
          </div>

        </FormItem>
        <FormItem label="状态：" prop="status">
          <i-switch v-model="createData.status" :true-value="1" :false-value="0" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
  import {
    postSales,
    getSales,
    delSales,
    putSales
  } from "@/api/admin";
  export default {
    data() {
      return {
        Selection: [],
        pageIndex: 1,
        pageSize: 10,
        total: "",
        cxName: "",
        showCreate: false,
        creating: true,
        loading: false,
        edit: false,
        createData: {
          name: "",
          discount: "",
          starttime: "",
          endtime: "",
          status: 1,
        },
        createRules: {
          name: [{
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }],
        },
        columns: [{
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "名称",
            key: "name",
            minWidth: 180,
          },
          {
            title: "折扣",
            key: "discount",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "活动开始时间",
            key: "starttime",
            align: "center",
            minWidth: 200,
          },
          {
            title: "活动结束时间",
            key: "endtime",
            align: "center",
            minWidth: 200,
          },
          {
            title: "状态",
            align: "center",
            slot: "status",
            minWidth: 100,
          },
          {
            title: "操作",
            minWidth: 130,
            align: "center",
            slot: "action",
          },
        ],
        data: [],
        load:true
      };
    },
    created() {
      this._getData();
    },
    watch: {
      cxName(newVal, oldVal) {
        if (newVal != oldVal) {
          (this.pageIndex = 1), (this.load = true), this._getData();
        }
      },
    },
    methods: {
      startChange(e) {
        this.createData.starttime = e;
      },
      endChange(e) {
        this.createData.endtime = e;
      },
      // 获取列表
      _getData() {
        getSales({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          name: this.cxName,
        }).then((res) => {
          this.data = res.data.data;
          this.total = res.data.total;
          this.Selection = [];
          this.load = false
        });
      },
      // 删除
      del(id) {
        this.$Modal.confirm({
          title: "删除确认",
          content: "删除活动后无法恢复，是否继续？",
          onOk: () => {

            this.delFunction(id);
          },
        });
      },
      // 删除所选
      allDel() {
        let arr = [];
        this.Selection.map(function (item) {
          arr.push(item.id);
        });
        this.del(arr);
      },
      // 删除方法
      delFunction(id) {
        this.loading = true
        this.load = false
        delSales({
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.loading = false
          this.Selection = [];
        });
      },

      //  新增按钮
      addClick() {
        this.edit = false;
        this.showCreate = true;
        this.createData.time = [];
      },

      // 新增方法
      addSave() {
        if (!this.createData.starttime || !this.createData.endtime) {
          this.$Message.warning({
            background: true,
            content: "请选择活动起止时间",
          });
          this.creating = false;
          this.$nextTick(() => {
            this.creating = true;
          });
          return;
        }
        if (this.createData.discount <= 0 || this.createData.discount > 99) {
          this.$Message.warning({
            background: true,
            content: "请输入正确的折扣比例",
          });
          this.creating = false;
          this.$nextTick(() => {
            this.creating = true;
          });
          return;
        }
        this.$refs.create.validate((valid) => {
          if (valid) {
            postSales({
              name: this.createData.name,
              discount: this.createData.discount,
              starttime: this.createData.starttime,
              endtime: this.createData.endtime,
              status: this.createData.status,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this._getData();
                this.createData.name = "";
                this.createData.starttime = "";
                this.createData.endtime = "";
                this.createData.discount = 0;
                this.createData.status = 1;
              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
            });
            this.showCreate = false;
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          } else {
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          }
        });
      },

      //  编辑按钮
      editClick(row) {
        this.edit = true;
        this.showCreate = true;
        this.createData = {
          ...row
        };
      },

      // 编辑方法
      editSave() {
        if (!this.createData.starttime || !this.createData.endtime) {
          this.$Message.warning({
            background: true,
            content: "请选择活动起止时间",
          });
          this.creating = false;
          this.$nextTick(() => {
            this.creating = true;
          });
          return;
        }
        if (this.createData.discount <= 0 || this.createData.discount > 99) {
          this.$Message.warning({
            background: true,
            content: "请输入正确的折扣比例",
          });
          this.creating = false;
          this.$nextTick(() => {
            this.creating = true;
          });
          return;
        }
        this.$refs.create.validate((valid) => {
          if (valid) {
            putSales({
              id: this.createData.id,
              name: this.createData.name,
              discount: this.createData.discount,
              starttime: this.createData.starttime,
              endtime: this.createData.endtime,
              status: this.createData.status,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this._getData();
                this.createData.name = "";
                this.createData.starttime = "";
                this.createData.endtime = "";
                this.createData.discount = 0;
                this.createData.status = 1;
              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
            });
            this.showCreate = false;
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          } else {
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          }
        });
      },

      // 分页跳转
      pageChange(val) {
        this.pageIndex = val;
        this.load = true
        this._getData();
      },
      pageSizeChange(val) {
        this.pageIndex = 1
        this.load = true
        this.pageSize = val;
        this._getData();
      },
      //多选
      handleSelectChange(val) {
        this.Selection = val;
      },
    },
  };
</script>

<style lang="less" scoped>
  .sm {
    font-size: 12px;
    line-height: 18px;
  }
</style>